(() => {
    const initMarquee = (options = {}) => {
        const defaultOptions = {
            selector: ".bg__marquee",
            tagSelector: ".bg__tag",
            speed: 100, // 속도 조절 (숫자가 클수록 빠름)
            offset: 4, // 오프셋 값
            ease: "none"
        };
        
        const settings = { ...defaultOptions, ...options };
        
        const marqueeElements = document.querySelectorAll(settings.selector);
        marqueeElements.forEach(marquee => {
            const tags = marquee.querySelectorAll(settings.tagSelector);
            tags.forEach(tag => {
                const clonedTag = tag.cloneNode(true);
                marquee.appendChild(clonedTag);
            });
        });
        
        marqueeElements.forEach(function(marquee) {
            const marqueeWidth = marquee.offsetWidth;
            const clonedMarquee = marquee.cloneNode(true);
            marquee.parentNode.appendChild(clonedMarquee);
            marquee.parentNode.parentNode.style.width = marqueeWidth + 'px';
            const animationDuration = marqueeWidth / settings.speed;
            
            gsap.to(marquee.parentNode, animationDuration, {
                x: "-" + (marqueeWidth + settings.offset),
                ease: settings.ease,
                repeat: -1
            });
        });
    }
    
    initMarquee();
})();